import apiClient from '../clienteFebosAPI';

const RESOURCE = '/empresas';

export const ioCompanyList = (pages, rows, simpleSearch, scope, domain) => (
  apiClient.get(RESOURCE, {
    operacionId: 'io.empresas.listar',
    _headers: {
      dominioPortal: domain
    }
  })
);

export const ioGetCompanies = ({ ...filters }) => {
  const params = apiClient.queryParams(filters);

  return apiClient.get(`${RESOURCE}?${params}`, {
    operacionId: 'io.empresas'
  });
};

export const ioGetCompanyData = (payload) => {
  const params = apiClient.queryParams(payload);

  return apiClient.get(`${RESOURCE}/${payload.companyIut}?${params}`, {
    operacionId: 'io.empresa.obtener'
  });
};

export const signsUser = (companyIut) => apiClient.get(`${RESOURCE}/${companyIut}/puedefirmar`,
  { operacionId: 'io.usuario.firmas' });

export const ioCompanyGroups = ({ empresaId: companyId, ...filters }) => {
  const params = apiClient.queryParams(filters);

  return apiClient.get(`${RESOURCE}/${companyId}/grupos?${params}`, {
    operacionId: 'io.empresas.grupos'
  });
};

export const getUsersByGroup = ({
  empresaId,
  pagina,
  filas,
  groupId,
  ...filters
}) => {
  const params = apiClient.queryParamsComponent({
    empresaId,
    pagina,
    filas,
    groupId,
    ...filters
  });

  return apiClient.get(
    `${RESOURCE}/${empresaId}/grupos/${groupId}/usuarios?${params}`, {
      operacionId: 'io.empresas.usuariosBygroup'
    }
  );
};

export const ioCompanyUpdateGroup = (empresaId, group) => {
  const params = apiClient.queryParams(group);
  return apiClient.put(`${RESOURCE}/${empresaId}/grupos/${group.id}?${params}`,
    group, { operacionId: 'io.empresas.update.group' });
};

export const ioCompanyCreateGroup = (empresaId, group) => {
  const params = apiClient.queryParams(group);
  return apiClient.post(`${RESOURCE}/${empresaId}/grupos?${params}`,
    group, { operacionId: 'io.empresas.create.group' });
};

export const ioCompanyRemoveGroup = (empresaIut, groupId) => {
  const params = apiClient.queryParams({ empresaId: empresaIut, grupoId: groupId });
  return apiClient.delete(`${RESOURCE}/${empresaIut}/grupos/${groupId}?${params}`,
    { operacionId: 'io.empresas.remove.group' });
};

export const ioCompanyUpdateUsersGroup = (empresaId, body) => {
  const params = apiClient.queryParams(body);
  return apiClient.post(`${RESOURCE}/${empresaId}/grupos/${body.grupoId}?${params}`,
    body, { operacionId: 'io.empresas.update.users.group' });
};

export const ioCompanyDeleteUsersGroup = (empresaId, grupoId, usuarioId) => apiClient.delete(
  `${RESOURCE}/${empresaId}/grupos/${grupoId}/usuarios`,
  { data: { usuarioId } },
  { operacionId: 'io.empresas.delete.users.group' }
);

export const ioCompanyAddUserToGroup = (empresaId,
  { groupId, userId, isLider = 'N' }) => apiClient.post(
  `${RESOURCE}/${empresaId}/grupos/${groupId}/usuarios`,
  {
    usuarioId: userId,
    esLider: isLider
  }, { operacionId: 'io.empresas.add.user.group' }
);

export const ioCompanyMarkLider = (empresaId, body) => {
  const params = apiClient.queryParams(body);
  return apiClient.post(`${RESOURCE}/${empresaId}/grupos/${body.grupoId}/usuarios?${params}`,
    body, { operacionId: 'io.empresas.markLider.users.group' });
};

export const ioCompanyUserSubstitute = (empresaId, substitute) => {
  const params = apiClient.queryParams(substitute);
  return apiClient.post(`${RESOURCE}/${empresaId}/usuarios/remplazos?${params}`,
    substitute, { operacionId: 'io.empresas.save.substitue' });
};

export const ioCompanyGetSubstitute = (payload) => {
  const params = apiClient.queryParams(payload);
  return apiClient.get(`${RESOURCE}/${payload.empresaId}/usuarios/remplazos?${params}`,
    { operacionId: 'io.empresas.get.substitue' });
};
export const ioCompanyGetAccessProfiles = (payload) => {
  const params = apiClient.queryParams(payload);
  return apiClient.get(`${RESOURCE}/${payload.empresaId}/perfiles?${params}`,
    { operacionId: 'io.empresas.get.access.profiles' });
};

export const getCompanyRoles = (payload) => {
  const params = apiClient.queryParams(payload.params);
  return apiClient.get(`${RESOURCE}/${payload.empresaId}/roles?${params}`, {});
};

export const ioListCompanyRole = (
  {
    companyId, filters,
    page = 1,
    limit = 20,
    permiso = undefined
  }
) => {
  const params = apiClient.queryParams({
    filtros: filters,
    pagina: page,
    itemsPorPagina: limit,
    permiso
  });
  return apiClient.get(`/v2/empresas/${companyId}/roles?${params}`,
    { operacionId: 'io.company.list.rol', permiso: 'ADM10' });
};

export const ioSaveCompanyRol = (
  companyId,
  rol = {
    nombre: '',
    descripcion: '',
    app: 'ED',
    ambito: 'cloud'
  }
) => apiClient.post(`/v2/empresas/${companyId}/roles`,
  rol, { operacionId: 'io.company.save.rol', permiso: 'ADM11' });

export const ioUpdateCompanyRol = (
  companyId,
  rolId,
  rol = {
    nombre: '',
    descripcion: '',
    app: 'ED',
    ambito: 'cloud'
  }
) => apiClient.put(`/v2/empresas/${companyId}/roles/${rolId}`,
  rol, { operacionId: 'io.company.save.rol', permiso: 'ADM13' });

export const ioDeleteCompanyRol = (
  companyId,
  rolId
) => apiClient.delete(`/empresas/${companyId}/roles/${rolId}`,
  { operacionId: 'io.company.delete.rol', permiso: 'ADM13' });

export const ioListCompanyRolPermission = (
  companyId,
  rolId
) => apiClient.get(`/v2/empresas/${companyId}/roles/${rolId}/permisos`,
  { operacionId: 'io.company.list.rol.permission', permiso: 'ADM11' });

export const ioSaveCompanyRolPermission = (
  companyId,
  rolId,
  permission = []
) => apiClient.post(`/v2/empresas/${companyId}/roles/${rolId}/permisos`,
  {
    permisos: permission
  }, { operacionId: 'io.company.save.rol.permission', permiso: 'ADM13' });

export const ioMigrateCompanyRolPermission = (
  companyId,
  rolId,
  environments = []
) => apiClient.post(`/empresas/${companyId}/roles/${rolId}/migrar`,
  {
    ambientes: environments.join(',')
  }, { operacionId: 'io.company.rol.migration', permiso: 'ADM11' });

export const ioCopiarCompanyRolPermission = (
  companyId,
  rolId,
  name = []
) => apiClient.put(`/empresas/${companyId}/roles/${rolId}/migrar`,
  {
    nuevoNombre: name
  }, { operacionId: 'io.company.rol.copy', permiso: 'ADM43' });

export const ioGetCompanyBranches = (payload) => {
  const params = apiClient.queryParams(payload);
  return apiClient.get(`${RESOURCE}/${payload.empresaId}/sucursales?${params}`,
    { operacionId: 'io.empresas.get.sucursales' });
};

export const ioGetCompanyBranchesV2 = ({
  iut, filter, page, limit = 0, order
}) => {
  const params = apiClient.queryParams(
    {
      filtros: filter,
      pagina: page,
      elementosPorPagina: limit,
      orden: order
    }
  );
  return apiClient.get(`/v2/empresas/${iut}/sucursales?${params}`,
    { operacionId: 'io.empresas.get.sucursales' });
};

export const ioGetCompanyInformation = ({
  iutEmpresa,
  params = {},
  seOmiteErrorReport = false
}) => {
  const queryParams = apiClient.queryParams(params);
  return apiClient.get(`${RESOURCE}/${iutEmpresa}?${queryParams}`,
    { operacionId: 'io.empresas.get.information', seOmiteErrorReport });
};
